import {Component, OnInit, Inject, NgZone} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'abw-confirm-dialog',
    templateUrl: './abw-confirm-dialog.component.html',
    styleUrls: ['./abw-confirm-dialog.component.scss']
})
export class AbwConfirmDialogComponent implements OnInit {
    title: string;
    message: string;

    constructor(
        public dialogRef: MatDialogRef<AbwConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private ngZone: NgZone
    ) {
        this.title = data.title;
        this.message = data.message;
    }

    ngOnInit() {
    }

    onConfirm(): void {
        this.ngZone.run(() => {
            this.dialogRef.close(true);
        });
    }
    
    onDismiss(): void {
        this.ngZone.run(() => {
            this.dialogRef.close(false);
        });
    }
}